import { useEffect } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import ThemeProvider from "../theme/ThemeProvider";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getUser, setAuth } from "store/slices/userSlice";
import routes from "./Routes";

import Navbar from "components/Navbar";
import Explore from "../views/Explore";
import Login from "views/Login";
import Register from "views/Register";
import Profile from "views/Profile";
import ProjectCreate from "views/ProjectCreate";
import Launch from "views/Launch";
import Projects from "views/Projects";
import ProjectPreview from "views/ProjectPreview";
import { fetchProjects } from "store/slices/exploreSlice";
import {
  fetchProjectsByMemberId,
  fetchProjectsByOwnerId,
} from "store/slices/projectsSlice";

const PrivateRoutes = ({ userId }: { userId: string }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProjects());
    dispatch(getUser(userId));
    dispatch(fetchProjectsByOwnerId(userId));
    dispatch(fetchProjectsByMemberId(userId));
  }, [dispatch, userId]);

  return (
    <>
      <Route exact path={routes.profile.root}>
        <Profile />
      </Route>
      <Route exact path={routes.explore.root}>
        <Explore />
      </Route>
      <Route exact path={routes.projects.new}>
        <ProjectCreate />
      </Route>
      <Route exact path={routes.explore.project}>
        <ProjectPreview />
      </Route>
      <Route exact path={routes.projects.root}>
        <Projects />
      </Route>
    </>
  );
};

const Main = () => {
  const dispatch = useAppDispatch();
  const localToken = localStorage.getItem("auth:token");
  const localUserId = localStorage.getItem("auth:userId");
  const { access_token, userId } = useAppSelector((state) => state.user.auth);

  useEffect(() => {
    if (localToken && localUserId && !access_token) {
      dispatch(setAuth({ access_token: localToken, userId: localUserId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localToken]);

  return (
    <BrowserRouter>
      <ThemeProvider>
        <Navbar />
        <Switch>
          <Route exact path={routes.launch}>
            <Launch />
          </Route>
          <Route exact path={routes.login}>
            <Login />
          </Route>
          <Route exact path={routes.register}>
            <Register />
          </Route>
          {access_token && userId ? <PrivateRoutes userId={userId} /> : null}
          <Route>
            <Redirect to={routes.login} />
          </Route>
        </Switch>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default Main;
